import { hasClass, addClass, removeClass, debounce } from './_utilities';
import Maps from './_loadMapBox';

// Element class name for brand select list
const brandSelect = 'availability-map__brand-select';

// Element class name for state select list
const stateSelect = 'availability-map__state-select';

// Element class name for the 'See Packages' button
const seePackagesButton = 'availability-map__see-packages';

// Visibility class for the 'See Packages' button
const buttonVisibleClass = 'availability-map__see-packages--visible';

// Bind to existing or create emtpy map object in module scope
let map = window.map || {};

// Set default provider value
let provider = 'tv-all';
let isNonTvProvider = '';
if (document.querySelector('.availability-map__map-container')) {
    isNonTvProvider = document
        .querySelector('.availability-map__map-container')
        .getAttribute('data-is-non-tv-provider');
}

// Load provider map layer and update button data attribute
const selectBrand = (target) => {
    const brand = target.options[target.selectedIndex].value;

    // map class method for loading brand layer
    // sanitizing brand by replacing the '-'
    if (isNonTvProvider === 'true') {
        map.loadProvider(`${brand.replace('-', '')}`);
    } else {
        map.loadProvider(`tv-${brand.replace('-', '')}`);
    }

    // Bind to CTA button element
    const button = document.querySelector(`.${seePackagesButton}`);

    // keep button disabled unless a brand is selected
    if (brand === 'all') {
        button.disabled = true;
    } else {
        button.disabled = false;
    }

    // Update button data attribute
    button.dataset.uri = brand;

    // Check if button has class and isn't brand 'all'
    if (!hasClass(button, buttonVisibleClass) && brand !== 'all') {
        addClass(button, buttonVisibleClass);
        // Otherwise remove the class if we have it and we're showing all
    } else if (hasClass(button, buttonVisibleClass) && brand === 'all') {
        removeClass(button, buttonVisibleClass);
    }
};

// Update button with URI for brand state geo URL
const selectState = (target) => {
    const state = target.options[target.selectedIndex].value;

    // Extract brand name from select data attribute
    const brand = document.querySelector('[data-map-brand-select]').dataset
        .mapBrandSelect;

    // Bind to CTA button element
    const button = document.querySelector(`.${seePackagesButton}`);

    // Update button data attribute
    button.dataset.uri = `${brand}/${state}`;

    // Check if button has class and isn't empty
    if (!hasClass(button, buttonVisibleClass) && state !== '') {
        addClass(button, buttonVisibleClass);
        // Otherwise remove the class if we don't have a state value, edge case
    } else if (hasClass(button, buttonVisibleClass) && state === '') {
        removeClass(button, buttonVisibleClass);
    }
};

// Redirects to /provider
const packageClickDebounce = debounce(
    (e) => {
        window.location = `/${e.target.dataset.uri}`;
    },
    500,
    true
);

// Create event listener for the 'details' button
const addButtonEventListener = () => {
    if (document.querySelector(`.${seePackagesButton}`) !== null) {
        // Bind variable to button element
        const button = document.querySelector(`.${seePackagesButton}`);
        // Add click event listener
        button.addEventListener('click', packageClickDebounce);
    }
};

// Use debounce utility method to throttle clicks on filter options
const brandSelectDebounce = debounce(
    (e) => {
        // Execute filter method on target
        selectBrand(e.target);
    },
    500,
    true
);

// Use debounce utility method to throttle clicks on filter options
const stateSelectDebounce = debounce(
    (e) => {
        // Execute filter method on target
        selectState(e.target);
    },
    500,
    true
);

// Create event listener for provider dropdown select element
const addBrandSelectListeners = () => {
    // Bind variable to select element
    const brands = document.querySelector(`.${brandSelect}`);

    if (brands !== null) {
        // Add change event listener
        brands.addEventListener('change', brandSelectDebounce);
    }
};

// Create state listener for provider dropdown select element
const addStateSelectListeners = () => {
    // Bind variable to select element
    const states = document.querySelector(`.${stateSelect}`);

    if (states !== null) {
        // Add change event listener
        states.addEventListener('change', stateSelectDebounce);
    }
};

// Add event listeners for map elements
const addListeners = () => {
    // Create event listeners for select dropdown
    addBrandSelectListeners();

    // Create event listeners for select dropdown
    addStateSelectListeners();

    // Create event listener for 'See Packages' button
    addButtonEventListener();
};

// Render map element
const displayMap = () => {
    // Bind variable to select element
    const states = document.querySelector(`.${stateSelect}`);

    // If we have the state selector, set the provider to the data attribute value
    if (states !== null) {
        if (isNonTvProvider === 'true') {
            const sanitizedProvider = states.dataset.mapBrandSelect.replace(
                '-',
                ''
            );
            provider = sanitizedProvider;
        } else {
            provider = `tv-${states.dataset.mapBrandSelect}`;
        }
    }

    // Setup options for Map object instance.
    const options = {
        provider,
        controls: true,
        locate: true,
        coder: false,
    };

    // Instantiate new map object, don't specify geo information unless you want it zoomed to those boundaries
    map = new Maps(null, null, options);

    // Render map on page
    map.displayMap();
};

// Module startup
const init = () => {
    // Bind to mapbox element to check if it's on page
    const mapbox = document.querySelector('#mapbox');

    // Only run through initialization if we have a element on page
    if (mapbox !== null) {
        // Bind map element event listeners
        addListeners();

        // Run through map initialization
        displayMap();
    }
};

export { init };
